import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Customers from "./pages/Customers";
import Debts from "./pages/Debts";
import Reports from "./pages/Reports";
import SinpeLog from "./pages/SinpeLog";
import CreditNotesReport from "./pages/CreditNotesReport";
import CustomersDedupe from "./pages/CustomersDedupe";
import Boxes from "./pages/Boxes";
import Banks from "./pages/Banks";
import Users from "./pages/Users";
import Expenses from "./pages/Expenses";
import ConsolidatedReport from "./pages/ConsolidatedReport";
import Sublimacion from "./pages/Sublimacion";
import EmergencyTools from "./pages/EmergencyTools";
import Arts from "./pages/Arts";
import ImportData from "./pages/ImportData";
import LabelGenerator from "./pages/LabelGenerator";
import Inventory from "./pages/Inventory";
import Apuestas from "./pages/Apuestas";
import LotteryAccess from "./pages/LotteryAccess";
import Layaways from "./pages/Layaways";
import SinpeVerify from "./pages/SinpeVerify";
import SuppliersInvoices from "./pages/SuppliersInvoices";
import PublicStore from "./pages/PublicStore";
import PublicResults from "./pages/PublicResults";
import Orders from "./pages/Orders";
import HR from "./pages/HR";
import Layout from "./components/Layout";
import { Toaster } from "@/components/ui/sonner";
import InstallPwaBanner from "./components/InstallPwaBanner";

// Suppress specific React DOM removeChild errors
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('removeChild') || 
     args[0].includes('NotFoundError'))
  ) {
    // Suppress the removeChild error
    return;
  }
  originalError.apply(console, args);
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const axiosInstance = axios.create({
  baseURL: API,
});

// Add auth interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axiosInstance.get('/auth/me')
        .then(res => {
          setUser(res.data);
        })
        .catch(() => {
          localStorage.removeItem('token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="text-xl">Cargando...</div>
    </div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* PUBLIC online store route (no login required) */}
          <Route path="/tienda/:slug" element={<PublicStore />} />
          <Route path="/resultados/:token" element={<PublicResults />} />
          <Route path="/login" element={
            user ? <Navigate to="/" /> : <Login setUser={setUser} />
          } />
          <Route path="/" element={
            user ? <Layout user={user} setUser={setUser} /> : <Navigate to="/login" />
          }>
            <Route index element={<Dashboard user={user} />} />
            <Route path="transactions" element={<Transactions user={user} />} />
            <Route path="customers" element={<Customers user={user} />} />
            <Route path="debts" element={<Debts user={user} />} />
            <Route path="sublimacion" element={<Sublimacion user={user} />} />
            <Route path="reports" element={<Reports user={user} />} />
            <Route path="sinpe-log" element={<SinpeLog />} />
            <Route path="credit-notes-report" element={<CreditNotesReport />} />
            <Route path="customers-dedupe" element={<CustomersDedupe />} />
            <Route path="consolidated" element={<ConsolidatedReport user={user} />} />
            <Route path="boxes" element={<Boxes user={user} />} />
            <Route path="banks" element={<Banks user={user} />} />
            <Route path="users" element={<Users user={user} />} />
            <Route path="expenses" element={<Expenses user={user} />} />
            <Route path="emergency" element={<EmergencyTools user={user} />} />
            <Route path="arts" element={<Arts user={user} />} />
            <Route path="import" element={<ImportData user={user} />} />
            <Route path="labels" element={<LabelGenerator user={user} />} />
            <Route path="inventory" element={<Inventory user={user} />} />
            <Route path="apuestas" element={<Apuestas user={user} />} />
            <Route path="lottery-access" element={<LotteryAccess user={user} />} />
            <Route path="suppliers" element={<SuppliersInvoices user={user} />} />
            <Route path="layaways" element={<Layaways user={user} />} />
            <Route path="sinpe-verify" element={<SinpeVerify user={user} />} />
            <Route path="orders" element={<Orders user={user} />} />
            <Route path="hr" element={<HR user={user} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster mobileOffset={{ bottom: 88 }} />
      <InstallPwaBanner />
    </div>
  );
}

export default App;